/**
 * Serviceplan MAKEOS
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface UpdateTaskStepDto { 
    plannedStartDate?: string;
    plannedEndDate?: string;
    startTime?: string;
    endTime?: string;
    totalHours?: number;
}

